/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
import { Accordion, AccordionProps } from '@mui/material'
import { styled } from '@mui/system'
import { useMedia } from '@/fractals/hooks'

function getRgbFromHex(hex: string) {
  hex = hex.replace(/^#/, '')
  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255
  return [r, g, b]
}

export const ContentAccordion = styled(
  (
    props: AccordionProps & {
      isBonusPart: boolean
      color: string
      isSmallScreen: boolean
    }
  ) => <Accordion disableGutters elevation={0} {...props} />
)(({ isBonusPart, color, isSmallScreen }) => ({
  '&:first-of-type': {
    'border-top-left-radius': '16px',
    'border-top-right-radius': '16px'
  },
  '&:last-of-type': {
    'border-bottom-left-radius': '16px',
    'border-bottom-right-radius': '16px'
  },
  backgroundColor: isBonusPart ? `rgb(${getRgbFromHex(color)}, 0.2)` : '#fff',
  filter: isBonusPart ? 'brightness(150%)' : 'unset',
  border: '1px solid #F2F2F2',
  color: '#000',
  fontSize: isSmallScreen ? '16px' : '24px',
  lineHeight: '120%',
  '&::before': {
    display: 'none'
  }
}))
